/**
 * The gable motif from the Bethel Innovations logo, redrawn as inline SVG for
 * use as a decorative background element. Always decorative — never the only
 * carrier of meaning, so it is aria-hidden everywhere it appears.
 */
const GableMark = ({ className = '', ...rest }) => (
  <svg
    className={className}
    viewBox="0 0 200 96"
    fill="none"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    <path
      d="M6 90 L100 8 L194 90"
      stroke="currentColor"
      strokeWidth="9"
      strokeLinecap="square"
    />
  </svg>
);

export default GableMark;
